module.exports = __webpack_public_path__ + "img/x9.15d9bf2f.jpg";